import styled from 'styled-components';

import {colors, font} from '@/app/styles/theme';

export const UserMenuLabel = styled.div`
    width: fit-content;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.brandPrimary};

    text-align: center;
    font-family: ${font.family.primary};
    font-size: 12px;
    font-weight: 600;
    line-height: 100%;
`;

export const UserMenuContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Avatar = styled.div`
    margin-left: 6px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: ${colors.brandPrimary};
    color: ${colors.white};
    display: flex;
    justify-content: center;
    align-items: center;

    text-align: center;
    font-family: ${font.family.primary};
    font-size: 12px;
    font-weight: 600;
    line-height: 100%;
`;
